import React, { useState, useContext, useEffect, useRef } from 'react';
import { Helmet } from "react-helmet";
import { useHistory } from 'react-router-dom';
import { LotTile } from './LotTile';
import { BidDialog } from './BidDialog';
import { AppDataContext, VLink } from "../AppDataContext";
import useNetwork from '../../useNetwork';
import useInfiniteScroll from "../../useInfiniteScroll";
import { urlEncodeText, computeSystemTimeDifference, getSecondsToTime } from '../../helpers';
import { Modal } from 'bootstrap';
import LoginAndRegistration from '../LoginAndRegistration';
import { Loader } from '../Loader';
import CurrencyFormat from 'react-currency-format';

export  function Auction (props) {
	const context = useContext(AppDataContext);
	const { loading, networkError, netRequest, netRenderError } = useNetwork(true);
	const [showReadOnlyTerms, setShowReadOnlyTerms] = useState(false);
	const [searchFieldValue, setSearchFieldValue] = useState(null);
	const [searchValue, setSearchValue] = useState(null);
	const [total, setTotal] = useState(null);

	const updateSearchFieldValue = (evt) => {
		setSearchFieldValue(evt.target.value);
		if (evt.target.value == null || evt.target.value.trim() === '') {
			setSearchFieldValue('');
			setSearchValue(null);
			setTotal(null);
			setSearchResults([]);
		}
	};

	const handleSearchKeyPress = (evt) => {
		if (evt.key === 'Enter' && evt.target.value && evt.target.value !== '') {
			setSearchValue(searchFieldValue);
		}
	}

	const [searchResults, setSearchResults] = useState([]);
	const searchAuction = (text) => {

		const search = async (search) => {
			const url = 'api/site/search/' + props.match.params.auctionId;
			console.log(url);
			const postData = {
				Search: search,
				Closed: null,
				Categories: null,
				OrderBy: 'LotNumber asc',
				Skip: 0,
				Take: 10000
			};
			const response = await netRequest(url, postData);

			if (response.data != null) {
				setTotal(response.data.totalLots);
				setSearchResults(response.data.lots);
			}
		};

		if (text != null && text !== '')
			search(text);
	}


	useEffect(() => {
		if (searchValue)
			searchAuction(searchValue)
	}, [searchValue]);


	const onApproved = () => {
		Modal.getInstance("#registerAuctionModal").hide();
		// register will get cause the lots to get fetched, so don't do them here, otherwise we get concurrent fetches which mess with startIx.current
		//fetchLots(true);
	};

	const registerLoggedIn = (loginResponse) => {
		// when we come back from login, if we're already registered for this auction,
		// then we can just close the dialog
		if (loginResponse.currentRegisteredAuctions.find(reg => reg.secureAuctionId == auction.auction.secureId))
			Modal.getInstance("#registerAuctionModal").hide();
		fetchLots(true);
	};

	const registerViewMoreModalClose = useRef(null);
	const viewMoreCloseToOpenRegister = () => {
		// using the register link to open another modal and the same link can't also close itself (this bootstrap modal) so we do it here
		registerViewMoreModalClose.current.click();
	};

	const startIx = useRef(0);
	// because the way that BS columns are working, we should have page sizes of multiples of 12, so we don't get
	// breaks in the middle of a row (it will normally show only 4, 3, or 2 per row, so multiples of 4 would probably work, too)
	const pageSize = useRef(null);
	// only call once on load
	if (pageSize.current === null) {
		const crawlers = ["Googlebot", "Google-InspectionTool", "Bingbot", "Slurp", "DuckDuckBot", "Baiduspider", "YandexBot",
			"Applebot", "BNDTest"];
		const lcAgent = navigator.userAgent.toLowerCase();
		pageSize.current = crawlers.some((crawler) => { return lcAgent.indexOf(crawler.toLowerCase()) > -1 }) ? 10000 : 12;
	}

	const [isFetching, setIsFetching, isDone, setIsDone] = useInfiniteScroll(fetchLots);
	const [endReached, setEndReached] = useState(false);
	const [totalLotsLeft, setTotalLotsLeft] = useState(null);

	const goToTop = () => {
		window.scrollTo(0, 0);
	};
	const goToBottom = () => {
		window.scrollTo(0, document.documentElement.offsetHeight);
	};
	const history = useHistory();

	const [auction, setAuction] = useState(null);
	const monitoringAuction = useRef(null);

	// because we need to reference the lot list in a callback from the SignalR Hub, we can't see the
	// state held value (it will only be its initial value and never change).  So we have to store it
	// in a ref, which we will set and synchronize with state at the same time
	const lotsRef = useRef([]);
	const [lots, _setLots] = useState([]);
	const setLots = (lots) => {
		lotsRef.current = lots;
		_setLots(lots);
	}

	const [systemSecondsToCloseDelta, setSystemSecondsToCloseDelta] = useState(0);
	const [auctionSecondsToClose, setAuctionSecondsToClose] = useState(null);

	const newBidPlaced = (bid, isBroadcast) => {
		if (bid.bidResultEnum === "LotWidthdrawn" || bid.bidResultEnum === "LotAdded") {
			// special case, not really a bid, but using the bid broadcast to notify anyone watching that
			// the lot has been widthdrawn from or added to the auction
			console.log('Lot ' + bid.lotSecureId + ': ' + bid.bidResultEnum);
			// close the bid dialog if it is open
			fetchLots(true);
		} else if (isBroadcast && bid.paddleNumber == monitoringAuction.current.auction.paddleNumber && bid.bidResultEnum != "BidOutbidByMax") {
			// if the bid paddle number from a broadcast coming in is the same as this user's paddle number, then
			// we just got a broadcast from a different tab/browser, or registration is complete, and the pending bids are coming in...
			// so the easiest thing to do us update the view
			console.log("  ...from another session");
			fetchLots(true);
		} else {
			console.log("  ...for lot " + bid.lotSecureId);
			// update the close time delta, as it might be different
			const localSystemSecondsToCloseDelta = computeSystemTimeDifference(bid.closeTime, bid.secondsToClose, new Date());
			setSystemSecondsToCloseDelta(localSystemSecondsToCloseDelta);

			// locate the lot for the LotTile we want to tell to update with a bid broadcast or as the result of a Place Bid
			// note that since we're in a callback in the Broadcast, we don't have access to the current lots state variable,
			// so we have to go to the Ref.  but to get state to update, we'll have to put the current into a NEW array
			let newLots = [...lotsRef.current];
			for (let ix = 0; ix < newLots.length; ix++) {
				if (newLots[ix].secureId === bid.lotSecureId) {
					if (bid.bidResultEnum === "NotApproved") {
						newLots[ix].pendingBidAmount = bid.pendingBidAmount;
					} else {
						bid.isBroadcast = isBroadcast;
						newLots[ix].currentBid = bid;

						newLots[ix].closeTime = bid.closeTime;
						newLots[ix].secondsToClose = bid.secondsToClose;
					}
					break;
				}
			}
			setLots(newLots);
		}
	};

	const newBidBroadcastRef = useRef(null);
	const newBidBroadcast = (event) => {
		newBidPlaced(event.detail, true);
	};


	// this useEffect has [] as the parms, so only gets call on didMount
	useEffect(() => {
		
		// kick off the countdown timer
		tick();

		// clean up if this effect gets called again
		return () => {
			// remove timer
			if (timer.current) {
				console.log('clearing timer');
				clearTimeout(timer.current);
			}
			if (fetchTimer.current != null) {
				console.log("Timer Fetch Canceled");
				clearTimeout(fetchTimer.current);
			}
		};
	}, []);

	useEffect(() => {
		if (auction) {
			if (context.hubConnected) {
				if (monitoringAuction.current.live) {
					newBidBroadcastRef.current = newBidBroadcast;
					context.subscribeToBids(auction.secureId, newBidBroadcastRef.current);
				}
			} else {
				console.log("Hub not up yet, subscribing later")
			}
		}
		return () => {
			// stop watching the bids for this auction
			if (newBidBroadcastRef.current != null) {
				context.unsubscribeToBids(monitoringAuction.current.secureId, newBidBroadcastRef.current);
				newBidBroadcastRef.current = null;
			}
		};
	}, [auction]);

	useEffect(() => {
		if (context.hubConnected === true && monitoringAuction.current != null && monitoringAuction.current.live) {
			if (newBidBroadcastRef.current == null) {
				newBidBroadcastRef.current = newBidBroadcast;
				context.subscribeToBids(monitoringAuction.current.secureId, newBidBroadcastRef.current);
			}
			if (startIx.current != 0) {
				console.log("Hub Connected, fetching current lots to refresh bids");
				fetchLots(true);
			}
		}
		if (context.hubConnected === false && newBidBroadcastRef.current != null && monitoringAuction.current != null) {
			context.unsubscribeToBids(monitoringAuction.current.secureId, newBidBroadcastRef.current);
			newBidBroadcastRef.current = null;
		}
	}, [context.hubConnected]);

	// whenever a tile's link is clicked, setup the scroll position and store it in the state so if back is pressed,
	// we will scroll back to the current location
	const lotTileLinkClicked = () => {
		const state = { scroll: document.documentElement.scrollTop, startIx: startIx.current };
		history.replace({ state: state });

		// also return to the Vlink call so that the detail page can store the parameters in the back to auction URL
		return state;
	}

	// this useEffect looks for changes in the auction Id parameter or login status
	useEffect(() => {
		if (props.match.params.auctionId) {
			console.log("Effect on Parms AuctionID");

			// when we get a change of any of the below parameters, we need to do a full refresh, including the
			// auction object, which only gets pulled when the startIx == 0
			startIx.current = 0;
			fetchLots(true, props.location.state);
		}
	}, [props.match.params.auctionId, context.isLoggedIn, context.registeredAuctionsChanged]);

	const fetchTimer = useRef(null);
	const lotCount = useRef(null);

	function fetchLots(fromBeginning, scrollEvent) {

		const getNextLots = async (startingAt, itemsToFetch, scrollPosition) => {
			if ((startingAt === 0 || startIx.current < lotCount.current) && (lotCount.current == null || lotCount.current > 0)) {

				// if they scroll while the timer is running, then kill the timer
				if (startIx.current > 0 && fetchTimer.current != null) {
					clearTimeout(fetchTimer.current);
					fetchTimer.current = null;
					console.log("Timer Fetch Canceled");
				}

				// set a flag that we're fetching the auction the "first time in".  since we're using a .current ref
				// and we're going off to the network, there is a chance another call will finish after we have not
				// requested the auction, and reset the .current to 0 after we didn't fetch the auction...  causing null ref errors
				const fetchAuction = startIx.current === 0;
				let url = 'api/site/';
				if (fetchAuction) 
					url += 'getauctionandlots';
				else
					url += 'getauctionlots';

				url += '/' + props.match.params.auctionId + '/' + startingAt + '/' + itemsToFetch;

				console.log(url);
				const response = await netRequest(url);

				if (response.data != null) {
					if (response.data.lots.length > 0) {
						// update the close time delta, as it might be different
						const firstLot = response.data.lots[0];
						// preview mode won't have close times for lots... so just use the 0 in the state...
						if (firstLot.closeTime != null)
							setSystemSecondsToCloseDelta(computeSystemTimeDifference(firstLot.closeTime, firstLot.secondsToClose, new Date()));
					}

					if (fetchAuction) {
						// only the first call to getauctionandlots returns an auction as the "data" root
						// the rest only set the lots property
						monitoringAuction.current = response.data;
						setAuction(response.data);

						// assign the paddle numbers for the auction, if set
						if (response.data.isRegistered) {
							context.setRegisteredAuction(response.data.secureAuctionId, response.data.paddleNumber);
						}

						// require the "optional text" tacked on the end of the url to be only one thing
						const encodedName = urlEncodeText(response.data.title);
						if (props.match.params.optionalTitle != encodedName) {
							history.replace('/Auction/' + props.match.params.auctionId + '/' + encodedName)
						}
					}

					// set our next starting point
					startIx.current = startingAt + itemsToFetch;

					if (response.data.lots.length == 0)
						lotCount.current = 0;
					else
						lotCount.current = response.data.remainingViewableLotCount;

					console.log("Response Processed: count==" + lotCount.current);

					if (lotCount.current < monitoringAuction.current.lotCount) {
						setTotalLotsLeft(lotCount.current);
					} else {
						setTotalLotsLeft(null);
					}

					const isEndReached = startIx.current >= lotCount.current;
					if (endReached === false && isEndReached === true)
						console.log("End of Auction reached");
					setIsDone(isEndReached);
					setEndReached(isEndReached);
					
					// back reference the auction in any lot that came down
					response.data.lots.forEach(l => {
						l.auctionSession = monitoringAuction.current;
						// refresh the selected lot, causing the bid dialog props.lot to refresh (allowing it to see if they have a paddle, yet)
						if (selectedLotRef.current != null && l.secureId === selectedLotRef.current.secureId) {
							setSelectedLot(l);
						}
					});

					if (startingAt === 0)
						setLots(response.data.lots);
					else
						setLots([...lots, ...response.data.lots]);

					if (scrollPosition != null) {
						window.scrollTo(0, scrollPosition);
					}
				}
            }
			setIsFetching(false);
		};

		// if the infinite scroll calls us (or manually requesting more from the button at the bottom),
		// the first param is empty, so not true
		let startingAt = fromBeginning === true ? 0 : startIx.current;
		let itemsToFetch = pageSize.current;
		let scrollTo = null;
		if (fromBeginning === true) {
			if (scrollEvent) {
				// when the back link is noted, these vars are passed in, so fetch the set amount and scroll
				itemsToFetch = scrollEvent.startIx;
				scrollTo = scrollEvent.scroll;
			} else if (startIx.current !== 0) {
				// any other time we ask to fetch from the beginning, we want to pull everything so far
				itemsToFetch = startIx.current;
			}
		} else {
			console.log("Scroll request");
			if (startIx.current === 0) {
				// often the last lot going off the page will trigger a scroll.  We can ignore that
				// as that lot's timer will pop and refresh
				console.log("Ignoring Scroll request when at beginning of list");
				return;
			}
		}

		getNextLots(startingAt, itemsToFetch, scrollTo);
	};


	const notifyClosed = (lot) => {
		lotCount.current--;
		if (lotCount.current == 0) {
			// last one gone, go back and refresh a new screenful.  in the slim chance that the
			// last lot gets bid on after disappearing, it will come back, now.  Otherwise, the
			// whole auction will show as sold
			lotCount.current = null;
			startIx.current = 0;
			console.log("startIx.current = 0");
			setLots([]);
		}
		console.log("notifyClosed, setting timer: count==" + lotCount.current);

		if (fetchTimer.current == null) {
			fetchTimer.current = setTimeout(() => {
				console.log("timer popped");
				fetchTimer.current = null;
				// fetch whatever amount they were looking at so far
				fetchLots(true);
			}, 4000);
		} else {
			console.log("Timer already set.  just let that one go");
		}
	};


	// opening a dialog is a bit of an effort.  We have a state var, openBidDialog
	// so that we can set the lot before we enable the dialog.  since the lot is null
	// when the page loads, we don't even have a dialog on the page.  once set
	// it will generate the dialog.  then we set the state to open the dialog so now
	// the useEffect watching openBidDialog will actually find the modal in the dom
	// i use a random number for the reinitialize property on the dialog component
	// so that we can change it, and the dialog will reset any state vars before opening
	const selectedLotRef = useRef(null)
	const [selectedLot, _setSelectedLot] = useState(null);
	const setSelectedLot = (lot) => {
		_setSelectedLot(lot);
		selectedLotRef.current = lot;
	}
	const [openBidDialog, setOpenBidDialog] = useState(false);
	const [reinitializeBidDialog, setReinitializeBidDialog] = useState(Math.random());

	const showBidDialog = async (lot) => {
		setSelectedLot(lot);
		setOpenBidDialog(true);
	}

	useEffect(() => {
		if (openBidDialog) {
			setReinitializeBidDialog(Math.random());
			var myModal = new Modal("#placeBidModal", {});
			myModal.show();
		}
		setOpenBidDialog(false);
	}, [openBidDialog]);

	// ref and state variable which are used to broadcast tick events to the tiles
	const timer = useRef(null);
	const [gmt, setGmt] = useState(new Date());

	const tick = () => {
		// set up timer
		timer.current = setTimeout(() => {
			// calling setGmt will cause the tiles to get alerted to update the timer they are showing
			setGmt(new Date());
			tick();
		}, 1000);
	}

	const [selectedSecondsToCLose, setSelectedSecondsToCLose] = useState(null);

	useEffect(() => {
		if (selectedLot && gmt) {
			setSelectedSecondsToCLose(getSecondsToTime(selectedLot.closeTime, gmt, systemSecondsToCloseDelta));
		}
		if (auction && gmt) {
			setAuctionSecondsToClose(getSecondsToTime(auction.closeTime, gmt, systemSecondsToCloseDelta));
		}
	}, [gmt, selectedLot, systemSecondsToCloseDelta]);

	const closeDialog = () => {
		Modal.getInstance("#registerAuctionModal").hide();
	};

	//if (networkError) {
	//	return netRenderError();
	//}

	if (auction == null) {
		return (
			<></>
		);
    }
	const days = Math.floor(auctionSecondsToClose / (60 * 60 * 24));
	const hours = Math.floor((auctionSecondsToClose - (days * 24 * 60 * 60)) / (60 * 60));
	const minutes = Math.floor((auctionSecondsToClose - (days * 24 * 60 * 60) - (hours * 60 * 60)) / (60));

    return (
		<main>
			<Helmet>
				<title>{auction.title.toUpperCase()}</title>

				<meta name="robots" content="index, follow" />
				<meta name="description" content={auction.title.replaceAll('"', '').toUpperCase()} />
				<meta property="og:title" content={auction.title.replaceAll('"', '').toUpperCase()} />
				<meta property="og:type" content="other" />
				{auction.auction.secureId != null &&
					<meta property="og:image" content={"https://" + window.location.hostname + '/api/site/auctionphoto/' + auction.secureId + '/450'} />
				}
				<meta property="og:image:width" content="450" />
				<meta property="og:image:height" content="450" />
				<meta property="og:url" content={window.location} />
				<meta name="twitter:card" content="summary" />
			</Helmet>

			<section class="container-fluid">
				<div class="row">
					<div class="col d-flex justify-content-center featured-auction-details " style={{ background: 'url("/api/site/auctionphoto/' + auction.secureId + '/750")', backgroundRepeat: 'no-repeat', backgroundSize: 'cover'}}>
						<div class="align-self-center m-3 p-3 featured-auction-details__content">
							<div class="featured-auction-details__content--auctioned-by border-bottom text-center pb-2 mb-2">
								Auctioned by <VLink to={"/seller/" + auction.auction.companySecureId} title={auction.auction.companyName}>
									<img src={"api/site/SellerLogo/" + auction.auction.companySecureId} alt={auction.auction.companyName} title={auction.auction.companyName} />
								</VLink>
							</div>
							{auctionSecondsToClose != null ?
								auction.closed ?
									<div class="featured-auction-details__content--time border-bottom text-center pb-2 mb-2 ml-2">
										Auction Closed {auction.closeTimeLocalStr}
									</div>
									: auctionSecondsToClose < 60 ?
										<div class="featured-auction-details__content--time border-bottom text-center pb-2 mb-2">
											Happening Now
										</div>
										:
										<>
											<div class="featured-auction-details__content--time border-bottom text-center pb-2 mb-2">
												<i class="bi bi-clock"></i>Sale begins to close {auction.closeTimeLocalStr}
											</div>
											<div class="row featured-auction-details__content--countdown">
												<div class="col text-center">
													{days > 0 && <span>{days}d </span>}
													{(days > 0 || hours > 0) && <span>{hours}h </span>}
													<span>{minutes}m</span>
												</div>
											</div>
										</>
								:
									<></>
							}
						</div>
					</div>
					<div class="col featured-auction">
						<div class="mx-auto px-3 py-5 featured-auction__content ">
							<h2 class="text-uppercase">{auction.title}</h2>
							<div class="d-flex auction-info">
								<div class="auction-info__item mb-3 me-3">
									<i class="bi bi-geo-alt"></i>
									{auction.auction.city}, {auction.auction.state }
								</div>
								<div class="auction-info__item mb-3 me-3">
									<i class="bi bi-tags"></i>
									{auction.lotCount} Lot{auction.lotCount != 1 && "s"}
								</div>
								<div class="auction-info__item mb-3 me-3">
									<i class="bi bi-currency-exchange"></i>
									{auction.auction.buyersPremiumStr}% Buyer's Premium
								</div>
							</div>
							<div class="divider"></div>
							<div className="summernote-html" dangerouslySetInnerHTML={{ __html: auction.auction.description }}></div>

							<ul class="nav nav-tabs nav-justified">
								<li class="nav-item">
									<a class="nav-link active" data-bs-toggle="tab" href="#pickup">Pickup Information</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" data-bs-toggle="tab" href="#aboutseller">About the Seller</a>
								</li>
							</ul>

							<div class="tab-content background-color position-relative">
								<div class="tab-pane container h-100 p-3 active" id="pickup">
									<div class="d-flex align-items-center pickup__content py-2">
										<div class="d-inline me-3">
											<i class="bi bi-pin-map"></i>
										</div>
										<div class="d-inline">
											<h4 class="mb-0 pb-0">
												{auction.auction.pickupOptionStrs.includes("PickupOnSite") ? (
													"Pickup on Location" +
													(auction.auction.pickupWindowStrs.length == 1 ? " - One Day Only" : "")
												) : (
													"Shipping Only"
												)}
											</h4>
											{auction.auction.pickupOptionStrs.includes("PickupOnSite") &&
												(auction.auction.pickupOptionStrs.includes("RelocateStore") ||
												auction.auction.pickupOptionStrs.includes("LocalDelivery") ||
												auction.auction.pickupOptionStrs.includes("ThirdPartyShip") ||
												auction.auction.pickupOptionStrs.includes("InHouseShip"))
												&&
												<h5 class="mb-0 pb-0">
													Alternative pickup &amp; shipping options available
												</h5>
											}
										</div>
									</div>

									<button class="btn btn-primary postion-relative mb-2 auctionTermsButton position-absolute-lg"
												data-bs-toggle="modal" data-bs-target="#registerAuctionModal"
												onClick={() => setShowReadOnlyTerms(true)} title="View more">View more</button>

									<div class="d-flex align-items-center pickup__content py-2">
										<div class="d-inline me-3">
											<i class="bi bi-clock"></i>
										</div>
										<div class="d-inline">
											<h4 class="mb-0 pb-0" >{auction.auction.city}, {auction.auction.state}</h4>
											{auction.auction.pickupWindowStrs.map((time, ix) => 
												<h5 key={"pw" + ix} class="mb-0 pb-0">{time}</h5>
											)}
										</div>
									</div>
									<div class="d-flex align-items-center pickup__content py-2">
										<div class="d-inline me-3">
											<i class="bi bi-arrow-clockwise"></i>
										</div>
										{auction.auction.pickupOptionStrs.includes("ReturnsAccepted") ?
												<div class="d-inline">
													<h4 class="mb-0 pb-0">Returns Accepted</h4>
													<h5 class="mb-0 pb-0">Read the Terms for Details</h5>
												</div>

											:
												<div class="d-inline">
													<h4 class="mb-0 pb-0">No Returns</h4>
													<h5 class="mb-0 pb-0">All sales are final</h5>
												</div>
										}
									</div>
								</div>
								<div class="tab-pane container h-100 p-3 fade" id="aboutseller">
									<div class="mb-1">
										<VLink to={"/seller/" + auction.auction.companySecureId} title={auction.auction.companyName}>
											{auction.auction.companyName}
										</VLink>
									</div>
									<div class="d-flex align-items-center pickup__content">
										<div class="d-inline me-3">
											{auction.auction.auctionManagerPhotoSecureId != null &&
												<img src={'api/site/AuctionManagerPhoto/' + auction.auction.auctionManagerPhotoSecureId + '/100'} title="Seller Image" alt="Seller Image" />
											}
										</div>
										<div class="d-inline">
											<h4 class="mb-0 pb-0" >{auction.auction.auctionManagerName}</h4>
											<h5>Auction Manager</h5>
											<div class="d-block align-items-center pickup__content">
												<i class="d-inline bi bi-telephone me-3"></i>
												<h5 class="d-inline mb-0 pb-0">{auction.auction.auctionManagerPhone}</h5>
											</div>
											<div class="d-block align-items-center pickup__content">
												<i class="d-inline bi bi-envelope me-3"></i>

												<h5 class="d-inline mb-0 pb-0"><a href={"mailto:" + auction.auction.auctionManagerEmail}>{auction.auction.auctionManagerEmail}</a></h5>
											</div>
										</div>

									</div>
								</div>
							</div>

							{
								(auction.auction.isRegistered != true && !auction.closed && !auction.draft) &&
								<p class="my-3">Get pre-approved to bid;
										&nbsp;
										<a href="#" data-bs-toggle="modal" data-bs-target="#registerAuctionModal"
											onClick={() => setShowReadOnlyTerms(false)} title="Register">click here</a>
										&nbsp;
										to register for this auction</p>
                            }

						</div>
					</div>
				</div>
			</section>
			<section class="background-primary">
				<div class="container pt-3 pb-5">
					<div class="d-lg-flex justify-content-between align-items-center sticky-top background-grey-lighter pt-2">
						<h2 class="text-left auction-grid-header">
							<span class="text-uppercase">{auction.title}</span>
							&nbsp;
							{totalLotsLeft ?
								<span>({totalLotsLeft} of {auction.lotCount} Lot{auction.lotCount !== 1 && "s"} Remaining)</span>
								:
									<span>({auction.lotCount} Lot{auction.lotCount !== 1 && "s"})</span>
							}
							<div class="divider my-2"></div>
						</h2>
						<div class="form-inline my-2 my-lg-0 search">
							<div class="input-group flex-nowrap">
								<span class="input-group-text">
									<i class="bi bi-search"></i>
								</span>
								<input class="form-control" type="search" placeholder="Search" aria-label="Search"
									onKeyDown={evt => handleSearchKeyPress(evt)}
									onChange={evt => updateSearchFieldValue(evt)}
									value={searchFieldValue}
								/>
								{navigator.userAgent.indexOf("Firefox/") > -1 &&
									<span class="mt-2 p-1">
										<i class="bi bi-x-circle" onClick={evt => updateSearchFieldValue({ target: { value: null } })}></i>
									</span>
								}
							</div>
						</div>
					</div>

					{searchValue &&
						<div>
							<div class="row">
								<div class="p-3 search-summary">
									<div class="search-summary__phrase">
										<h1 class="text-left">Searching for {searchValue}</h1> {total != null && <span class="results">({total} Results)</span>}
									</div>
								</div>
								{total == null && 
									<Loader loading={loading} />
								}
							</div>
							<div class="row">
								<div class="col-12 mb-1">
									<div class="table-responsive">
										<table class="table table-striped align-middle table-borderless">
											<thead>
												<tr>
													<th scope="col"></th>
													<th scope="col">Lot #</th>
													<th scope="col">Title</th>
													<th scope="col" class="text-center">Price</th>
													<th scope="col" class="text-end">Ending</th>
												</tr>
											</thead>
											<tbody>
												{searchResults && searchResults.length > 0 ?
													searchResults.map(lot => (
														<tr>
															<td>
																{lot.imageSecureId &&
																	<img src={"/api/site/inventoryimage/" + lot.imageSecureId + "/30"} title={lot.title} alt={lot.title} />
																}
															</td>
															<td class="text-end">
																{lot.lotNumber}
															</td>

															<td>
																<VLink to={"/auction/" + lot.auctionSessionSecureId + "/lot/" + lot.secureId}
																	title={lot.title} className="text-uppercase">
																	{lot.title}
																</VLink>
															</td>
															<td class="text-end">
																{auction.closed && !context.isLoggedIn ?
																	<span>Log in to see</span>
																	:
																	<CurrencyFormat decimalScale={2} fixedDecimalScale={true} value={lot.currentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} />
																}
															</td>
															<td class="text-end">
																{lot.isClosed ? "Closed" : lot.closeTimeLocalStr ?? "Preview" }
															</td>
														</tr>

													)) :
													<tr>
														<td></td>
														<td></td>
														<td></td>
														<td></td>
														<td></td>
													</tr>
												}
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					}

					<div className={"row mt-5 px-2" + (searchValue ? " d-none" : "")}>
 						
						{
							lots.map((l) => (

								<LotTile auctionId={auction.secureId}
									lot={l}
									currentBid={l.currentBid}
									key={l.secureId}
									gmt={gmt}
									systemSecondsToCloseDelta={systemSecondsToCloseDelta}
									onPlaceBid={showBidDialog}
									showClosed={auction.closed}
									notifyClosed={notifyClosed}
									onLinkClicked={lotTileLinkClicked}
									/>
								 
							))
						}	
						{isFetching && !isDone && <div>Fetching More...</div>}
						{(!isFetching && !endReached) &&
							<button onClick={fetchLots} class="btn btn-secondary" title="Fetch More...">
								Fetch More <i class="bi bi-arrow-right-short"></i>
							</button>
						}
						{endReached && <div class="col-12"><p class="text-center end-of-auction">End of Auction</p></div>}

						 
					</div>
				</div>
			</section>

			{selectedLot &&
				<BidDialog
				id="placeBidModal"
				lot={selectedLot}
				onBidPlaced={newBidPlaced}
				showConfirm={false}
				reinitialize={reinitializeBidDialog}
				secondsToClose={selectedSecondsToCLose}
				/>
			}

			{auction &&
				<div class="modal fade" id="registerAuctionModal" tabindex="-1" aria-labelledby="registerAuctionModalLabel" aria-hidden="true">
					<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
						<div class="modal-content">
							<div class="modal-header">
								<div class="mx-auto text-center lot-details__div__auctioned">
									Auctioned by <VLink to={"/seller/" + auction.auction.companySecureId} title={auction.auction.companyName}
										onClick={closeDialog}>
										<img src={"api/site/SellerLogo/" + auction.auction.companySecureId} alt={auction.auction.companyName} title={auction.auction.companyName} />
									</VLink>
								</div>
								<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
							</div>

							<div class="modal-body">
								<LoginAndRegistration
									showLogin={true}
									showSignup={true}
									registrationComplete={registerLoggedIn}
									showReadOnlyTerms={showReadOnlyTerms}
									auctionSession={auction}
									onApproved={onApproved}
								/>
								{(!auction.auction.isRegistered && !auction.closed && !auction.draft && showReadOnlyTerms) &&
									<div>
										<p class="my-3 text-center">Get pre-approved to bid;&nbsp;
											<a href="javascript:void(0)" onClick={() => setShowReadOnlyTerms(false)} title="Register">click here</a>;&nbsp;
											to register for this auction</p>
									</div>
								}
								{showReadOnlyTerms &&
									<button type="button" class="btn btn-primary" data-bs-dismiss="modal">Close</button>
								}
							</div>
						</div>
					</div>
				</div>
			}

 		</main>

    );
}
